import printItemListDialogTemplate from './printItemListDialog.template.html';

/*******************************************************************************
 * Service: PrintItemListDialog
 *
 * Provides filtering options to print a list of items for the organization.
 *******************************************************************************/
/* @ngInject */ export function PrintItemListDialogService($uibModal, uiGridConstants, BooksSettings, ItemTypes) {
  /** Dialog Controller. */
  var PrintItemListController = function ($scope, itemCategories) {
    /***************************************************************************
     * Properties
     ***************************************************************************/
    /*-----------------------*/
    /* Set up dataproviders. */
    /*-----------------------*/
    $scope.dpCategories = itemCategories;
    $scope.dpTypes = ItemTypes;
    $scope.dpViews = [
      { label: 'Web Store Only', webstore: true },
      { label: 'Non-Web Store Only', webstore: false }
    ];

    /*------------------------*/
    /* Select first category. */
    /*------------------------*/
    $scope.selectedCategory = $scope.dpCategories[0];

    /*---------------------------------------------------------------------*/
    /* Set dialog defaults. Initialize the multiSelects to select all by   */
    /* creating a new instance of each dataprovider as the ngModel's list. */
    /*---------------------------------------------------------------------*/
    $scope.selectedTypes = $scope.dpTypes.concat();
    $scope.selectedViews = $scope.dpViews.concat();
    $scope.reportFormat = 'PDF';

    /***************************************************************************
     * generateList */
    /**
     * Call page with filters to generate item list.
     ***************************************************************************/
    $scope.generateList = function () {
      /*--------------------------------------------*/
      /* Filter view options for web store. Get the */
      /* value from the first item if available.    */
      /*--------------------------------------------*/
      var optWS = $scope.selectedViews || [];
      var wsValue = optWS.length ? optWS[0].webstore : false;

      /*---------------------------------------------*/
      /* Create a map of ids for the selected types. */
      /*---------------------------------------------*/
      var typeIDs = ($scope.selectedTypes || []).map(function (type) {
        return type.value;
      });

      /*-----------*/
      /* Build url */
      /*-----------*/
      var url =
        'PrintItems.aspx?rt=' +
        $scope.reportFormat +
        '&cid=' +
        $scope.selectedCategory.id +
        ($scope.selectedTypes.length != $scope.dpTypes.length
          ? '&its=' + typeIDs.join(',')
          : '') +
        /*----------------------------------------------------------*/
        /* Add the webStore variable if there is only one selection */
        /*----------------------------------------------------------*/
        (optWS.length == 1 ? '&ws=' + wsValue : '');

      window.open(url);
    };
  };

  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog with options for printing items lists.
   *
   * @param  itemCategories  List of item categories
   * @return                 Promise to listen on
   *****************************************************************************/
  this.show = function (itemCategories) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      resolve: {
        itemCategories: function () {
          return itemCategories;
        }
      },
      controller: PrintItemListController,
      size: 'md',
      template: printItemListDialogTemplate
    }).result;
  };
}
